export default "__VITE_ASSET__bf996c33__"